<section class="p-6 space-y-8">
  <div class="space-y-3">
    <div class="space-y-1">
      <p class="text-lg font-semibold tracking-tight">Export user data</p>
      <p class="text-sm text-slate-500">
        Request a CSV containing Custie IDs, income, assets, payment metadata, preferences, household counts, and tracking fields.
        We will email you a link that opens this page and starts the download with a short-lived URL.
      </p>
    </div>
    <button
      pButton
      type="button"
      label="Download enriched user CSV"
      icon="pi pi-download"
      (click)="requestUserExport()"
      [loading]="userLoading()"
      [disabled]="userLoading()"
    ></button>
    <p *ngIf="userMessage()" class="text-sm text-green-700">{{ userMessage() }}</p>
    <p *ngIf="userError()" class="text-sm text-red-700">{{ userError() }}</p>
  </div>

  <div class="space-y-3 border-t border-slate-200 pt-6">
    <div class="space-y-1">
      <p class="text-lg font-semibold tracking-tight">Export pre-cancel notification events</p>
      <p class="text-sm text-slate-500">
        For each user who requested cancellation, download the notifications they received the day before their request,
        plus their email/SMS/push settings.
      </p>
    </div>
    <button
      pButton
      type="button"
      label="Download cancel-events CSV"
      icon="pi pi-download"
      (click)="requestCancelEventsExport()"
      [loading]="cancelLoading()"
      [disabled]="cancelLoading()"
    ></button>
    <p *ngIf="cancelMessage()" class="text-sm text-green-700">{{ cancelMessage() }}</p>
    <p *ngIf="cancelError()" class="text-sm text-red-700">{{ cancelError() }}</p>
  </div>

  <div class="space-y-3 border-t border-slate-200 pt-6">
    <div class="space-y-1">
      <p class="text-lg font-semibold tracking-tight">Export lottery eligibility impact</p>
      <p class="text-sm text-slate-500">
        For each lottery, download counts of eligible paid users with and without auto-apply whose paid period overlapped the open window,
        alongside lottery name, id, open/close dates, and units available.
      </p>
    </div>
    <button
      pButton
      type="button"
      label="Download lottery eligibility CSV"
      icon="pi pi-download"
      (click)="requestLotteryExport()"
      [loading]="lotteryLoading()"
      [disabled]="lotteryLoading()"
    ></button>
    <p *ngIf="lotteryMessage()" class="text-sm text-green-700">{{ lotteryMessage() }}</p>
    <p *ngIf="lotteryError()" class="text-sm text-red-700">{{ lotteryError() }}</p>
  </div>

  <div class="space-y-3 border-t border-slate-200 pt-6">
    <div class="space-y-1">
      <p class="text-lg font-semibold tracking-tight">Export applications</p>
      <p class="text-sm text-slate-500">
        CSV of all lottery applications with status, method, dates, and lottery names.
      </p>
    </div>
    <button
      pButton
      type="button"
      label="Download applications CSV"
      icon="pi pi-download"
      (click)="requestApplicationsExport()"
      [loading]="applicationsLoading()"
      [disabled]="applicationsLoading()"
    ></button>
    <p *ngIf="applicationsMessage()" class="text-sm text-green-700">{{ applicationsMessage() }}</p>
    <p *ngIf="applicationsError()" class="text-sm text-red-700">{{ applicationsError() }}</p>
  </div>

  <div class="space-y-3 border-t border-slate-200 pt-6">
    <div class="space-y-1">
      <p class="text-lg font-semibold tracking-tight">Export customer data</p>
      <p class="text-sm text-slate-500">
        CSV of all users with demographics (age, gender), household composition (adult/child roommates),
        income breakdown, assets, subscription details (start/stop, platform), preferences, and acquisition data.
      </p>
    </div>
    <button
      pButton
      type="button"
      label="Download customer data CSV"
      icon="pi pi-download"
      (click)="requestCustomerDataExport()"
      [loading]="customerDataLoading()"
      [disabled]="customerDataLoading()"
    ></button>
    <p *ngIf="customerDataMessage()" class="text-sm text-green-700">{{ customerDataMessage() }}</p>
    <p *ngIf="customerDataError()" class="text-sm text-red-700">{{ customerDataError() }}</p>
  </div>

  <div class="space-y-3 border-t border-slate-200 pt-6">
    <div class="space-y-1">
      <p class="text-lg font-semibold tracking-tight">Export unknown emails</p>
      <p class="text-sm text-slate-500">
        CSV of all emails with an unrecognised subject, including user ID, recipient, sender, and subject.
      </p>
    </div>
    <button
      pButton
      type="button"
      label="Download unknown emails CSV"
      icon="pi pi-download"
      (click)="requestUnknownEmailsExport()"
      [loading]="unknownEmailsLoading()"
      [disabled]="unknownEmailsLoading()"
    ></button>
    <p *ngIf="unknownEmailsMessage()" class="text-sm text-green-700">{{ unknownEmailsMessage() }}</p>
    <p *ngIf="unknownEmailsError()" class="text-sm text-red-700">{{ unknownEmailsError() }}</p>
  </div>
</section>
